<template>
  <div class="wrapper">
    <loading name="lp" :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <notifications></notifications>
    <parallax
      class="page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"></div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section pb-0">
        <div class="container t1">
          <h2 class="section-title">₼ {{labels.findTitle}}</h2>
          <div class="md-layout">
            <div class="md-layout-item md-size-100 md-small-size-100"></div>
          </div>
          <div class="md-layout">
            <div class="md-layout-item md-size-25 md-small-size-100">
              <md-field>
                <label>{{labels.search}}</label>
                <md-input v-model="search"></md-input>
                <router-link
                  @click.native="onSearchClick"
                  :to="'/' + id + (search ?  '/search/' + search + rnd + '#t0' : '')"
                >
                  <md-icon>search</md-icon>
                </router-link>
              </md-field>
              <h4 style="text-align: center">{{labels.or}}</h4>
              <div style="text-align: center">
                <span>{{labels.selectcat}}</span>
              </div>
              <collapse
                class="md-layout-item"
                :langEnabled="true"
                :active-tab="1"
                :collapse="first"
                icon="keyboard_arrow_down"
                color-collapse="rose"
                ref="colcats"
              >
                <template v-for="(item, index) in first" :slot="'md-collapse-pane-' + (index + 1)">
                  <md-list :key="item.id">
                    <md-list-item
                      v-if="item.child > 1"
                      :to="'/' + id + '/' + item.id + '/all#t0'"
                    >{{labels.showall}}</md-list-item>
                    <md-list-item
                      :key="subitem.id"
                      replace
                      v-for="(subitem) in subcategories(item.id)"
                      :to="'/' + id + '/' + item.id + '/' + subitem.id + '#t0'"
                    >{{ subitem.name }}</md-list-item>
                  </md-list>
                </template>
              </collapse>
            </div>

            <div class="md-layout-item md-size-75 md-small-size-100">
              <h3 id="t0">{{catpath}}</h3>
              <span
                class="md-helper-text"
                style="padding-top: 10px"
                v-if="search !== ''"
              >{{labels.found + ': ' + dscount}}</span>
              <div class="md-layout">
                <div
                  class="md-layout-item md-size-33 md-small-size-100"
                  :key="dish.id"
                  v-for="dish in ds"
                >
                  <product-card
                    text-center
                    class="mt-3"
                    card-plain
                    :card-image="dish.picture=== null ? nophoto : fileurl + dish.picture"
                    :shadow-off="true"
                    :id="dish.id"
                    @clicked="showImages"
                    :popular="dish.selected === '1'"
                    :visible="dish.visible === '1'"
                    :discount="dish.discount === '1'"
                  >
                    <template slot="cardContent">
                      <h3 class="card-title">{{dish.title}}</h3>
                      <p class="card-description">
                        <span style="font-size: 18px">{{dish.description}}</span>
                      </p>
                    </template>
                    <template slot="cardAction">
                      <div class="md-layout">
                        <div class="md-layout-item md-size-100">
                          <div
                            class="md-layout-item md-size-100"
                            :key="price.name"
                            v-for="price in dish.price"
                          >
                            <div class="md-layout">
                              <div class="md-layout-item md-size-50 text-left">
                                <span style="font-size: 16px">{{price.name}}</span>
                              </div>
                              <div class="md-layout-item md-size-50 text-right">
                                <div class="price-container">
                                  <span
                                    v-if="price.priceold > price.price"
                                    class="price price-old"
                                  >₼ {{price.priceold}}</span>
                                  <span class="price price-new">₼ {{price.price}}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="md-layout-item md-size-100">
                          <div class="md-layout md-alignment-center-center" style="padding: 10px">
                            <md-button class="md-success md-round" @click="showToBasket(dish)">
                              <md-icon>shopping_basket</md-icon>
                              {{labels.tobasket}}
                            </md-button>
                          </div>
                        </div>
                        <div class="md-layout-item md-size-100" v-if="dish.ingradient">
                          <div class="md-layout md-alignment-center-center">
                            <el-popover
                              placement="top"
                              title
                              width="250"
                              trigger="click"
                              :content="dish.ingradient"
                            >
                              <el-button slot="reference" type="text">
                                <span>{{labels.showIngradient}}</span>
                              </el-button>
                            </el-popover>
                          </div>
                        </div>
                        <div class="md-layout-item md-size-100">
                          <div class="md-layout md-alignment-center-left">
                            <small v-if="dish.availablefrom || dish.availableto" style="margin-left: 25px; font-size: 12px">
                              {{labels.available}}: {{dish.availablefrom ? dish.availablefrom : ""}} {{dish.availableto ? " - " + dish.availableto : ""}}
                            </small>
                          </div>
                          <div class="md-layout md-alignment-center-left">
                            <small v-if="dish.notes" style="margin-left: 25px; font-size: 12px">
                              <i>{{ '* ' + dish.notes }}</i>
                            </small>
                          </div>
                        </div>
                      </div>
                    </template>
                  </product-card>
                </div>
              </div>
            </div>
            <div class="md-layout" v-if="dishes.length > 0">
              <div class="md-layout-item md-size-25 md-small-size-100">
                <span style="font-size: 12px">{{'P: 193' + visits}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="sticky-ordernow" v-if="$store.getters.orderTotal > 0">
        <md-button class="md-primary md-round" @click="onOrder">
          <md-icon>shopping_basket</md-icon> {{ labels.ordernow}}: ₼
          {{ $store.getters.orderTotal }}
        </md-button>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" :fullscreen="true" :center="true">
      <el-carousel trigger="hover" :interval="5000">
        <el-carousel-item v-for="item in carousel" :key="item.name">
          <el-image style="width: 100%; height: 100%" :src="fileurl + item.name" fit="contain"></el-image>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>

    <div class="md-layout">
      <div class="md-layout-item md-size-50 md-small-size-100">
        <div class="modal modal-bg" :class="{ show: tobasketModal }">
          <modal v-if="tobasketModal" type="modal-50" @close="tobasketModal = false">
            <template slot="header">
              <h4 class="modal-title"></h4>
              <md-button
                class="md-simple md-close md-just-icon md-round modal-default-button"
                @click="tobasketModal = false"
              >
                <md-icon>clear</md-icon>
              </md-button>
            </template>

            <template slot="body">
              <div class="md-layout">
                <div class="md-layout-item md-small-size-100 md-size-33">
                  <img
                    style="width: 200px; height: 150px"
                    :src="newItem.picture=== null ? nophoto : fileurl + newItem.picture"
                  />
                  <h4 class="title">{{newItem.title}}</h4>
                </div>

                <div class="md-layout-item md-small-size-100 md-size-67">
                  <div class="md-layout vertical-center">
                    <div
                      class="md-layout-item md-small-size-100 md-size-33 text-left"
                    >{{labels.price}}</div>
                    <div class="md-layout-item md-small-size-100 md-size-67 text-left">
                      <el-select
                        v-model="newItem.priceid"
                        placeholder="Select"
                        :disabled="addedToBasket"
                        @change="onSelected"
                      >
                        <el-option
                          v-for="price in newItemPrices"
                          :key="price.id"
                          :label="price.name + ': ₼' + price.price"
                          :value="price.id"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="md-layout padding-top-20 vertical-center">
                    <div
                      class="md-layout-item md-small-size-100 md-size-33 text-left"
                    >{{labels.count}}</div>
                    <div class="md-layout-item md-small-size-100 md-size-67 text-left">
                      <span style="padding-right: 20px">{{ newItem.count }}</span>
                      <div class="md-group" v-if="!addedToBasket">
                        <md-button class="md-round md-info md-sm" @click="increaseQuantity()">
                          <md-icon>add</md-icon>
                        </md-button>
                        <md-button class="md-round md-info md-sm" @click="decreaseQuantity()">
                          <md-icon>remove</md-icon>
                        </md-button>
                      </div>
                    </div>
                  </div>

<div class="md-layout padding-top-20 vertical-center" v-if="newItem.availablefrom || newItem.availableto">
                    <div
                      class="md-layout-item md-small-size-100 md-size-33 text-left"
                    >{{labels.available}}</div>
                    <div class="md-layout-item md-small-size-100 md-size-67 text-left">
                      <span>
                              {{newItem.availablefrom ? newItem.availablefrom : ""}} {{newItem.availableto ? " - " + newItem.availableto : ""}}
                            </span>
                    </div>
                  </div>
                  <div class="md-layout padding-top-20 vertical-center">
                    <div class="md-layout-item md-small-size-100 md-size-33 text-left"></div>
                    <div class="md-layout-item md-small-size-100 md-size-67 text-left">
                      <h3>
                        <b>{{labels.total}}: ₼ {{newItem.amount}}</b>
                      </h3>
                      <md-button
                        v-if="!addedToBasket"
                        @click="onAddToBasket"
                        class="md-round md-success"
                      >{{labels.tobasket}}</md-button>
                    </div>
                  </div>
                  <div v-if="addedToBasket" class="md-layout padding-top-20 vertical-center">
                    <md-button
                      @click="tobasketModal = false"
                      class="md-simple md-success"
                    >{{labels.continueshop}}</md-button>
                    <md-button
                      @click="onGoToBasket"
                      class="md-round md-primary"
                    >{{labels.gotobasket}}</md-button>
                  </div>
                </div>
              </div>
            </template>

            <template slot="footer"></template>
          </modal>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="langVisible" :fullscreen="true" :center="true" :show-close="false">
      <div class="md-layout md-alignment-center-center">
        <div class="md-layout-item md-small-size-100 md-size-33">
          <h4 style="text-align: center">Dili seçin / Select language / Выберите язык</h4>
          <md-button style="width: 100%" class="md-raised" to @click.native="onLang('AZ')"><img :src="azflag" /><span style="padding-left: 10px">Azərbaycan</span></md-button>
          <br />
          <md-button style="width: 100%" to @click.native="onLang('EN')"><img style="margin-left: -30px" :src="enflag" /><span style="padding-left: 10px"> English</span></md-button>
          <br />
          <md-button style="width: 100%" to @click.native="onLang('RU')"><img style="margin-left: -25px" :src="ruflag" /><span style="padding-left: 10px">Русский</span></md-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ProductCard, Collapse, Slider, Modal } from "@/components";
import { mapState } from "vuex";
import Mixins from "@/plugins/basicMixins";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { fileUrl, nophoto, Round2, AZ_Flag, RU_Flag, EN_Flag } from "../services/helper";
import { VisitCount } from "../services/share";
import {
  Popover,
  Button,
  Carousel,
  CarouselItem,
  Dialog,
  Card,
  Image,
  Backtop,
  Select,
  Option
} from "element-ui";
export default {
  components: {
    ProductCard,
    Collapse,
    Loading,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
    [Popover.name]: Popover,
    [Button.name]: Button,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem,
    [Dialog.name]: Dialog,
    [Card.name]: Card,
    [Image.name]: Image,
    [Backtop.name]: Backtop
  },
  props: {
    id: String,
    cid: String,
    subid: String
  },
  mixins: [Mixins.HeaderImage],
  data() {
    return {
      nophoto: nophoto,
      isActive: 1,
      colorCollapse: "primary",
      isLoading: false,
      catpath: "",
      carousel: [],
      dialogVisible: false,
      langVisible: false,
      labels: {
        showIngradient: this.localeLabel("ingrad"),
        findTitle: this.localeLabel("filter"),
        showall: this.localeLabel("showall"),
        search: this.localeLabel("search"),
        found: this.localeLabel("found"),
        result: this.localeLabel("searchresult"),
        or: this.localeLabel("or"),
        selectcat: this.localeLabel("selectcat"),
        tobasket: this.localeLabel("tobasket"),
        price: this.localeLabel("price"),
        total: this.localeLabel("total"),
        count: this.localeLabel("count"),
        continueshop: this.localeLabel("continueshop"),
        gotobasket: this.localeLabel("gotobasket"),
        available: this.localeLabel("available"),
        ordernow: this.localeLabel("ordernow"),
      },
      search: "",
      visits: "",
      rnd: 0,
      tobasketModal: false,
      newItem: {
        id: "",
        title: "",
        picture: "",
        priceid: "",
        spec: "",
        price: 0,
        count: 1,
        discount: 0,
        amount: 0
      },
      newItemPrices: [],
      addedToBasket: false,
      azflag: AZ_Flag,
      enflag: EN_Flag,
      ruflag: RU_Flag
    };
  },

  methods: {
    onLang(lg) {
      this.$store.dispatch("setLang", lg);
      this.$router.go();
    },
    subcategories(id) {
      return this.cats.filter(c => c.parentid === id);
    },
    refreshPath() {
      if (this.search === "" && this.cid !== "search") {
        if (this.subid === "all" || !this.subid)
          this.catpath = this.first[this.$refs.colcats.isActive - 1].name;
        else
          this.catpath =
            this.first[this.$refs.colcats.isActive - 1].name +
            " / " +
            this.cats.filter(c => c.id === this.subid)[0].name;
      } else {
        this.catpath = this.labels.result + ": '" + this.search + "'";
      }
    },
    showImages(id) {
      this.carousel = [];
      this.carousel = this.dishes.filter(d => d.id === id)[0].images;
      if (this.carousel) this.dialogVisible = true;
    },
    onSearchClick() {
      if (this.search === "") {
        this.$refs.colcats.isActive = 1;
        this.refreshPath();
      } else this.rnd = Math.floor(Math.random() * 100);
    },
    increaseQuantity() {
      this.newItem.count++;
      this.computeAmount();
    },
    decreaseQuantity() {
      if (this.newItem.count > 1) {
        this.newItem.count--;
        this.computeAmount();
      }
    },
    onSelected() {
      let price = this.newItemPrices.filter(
        c => c.id === this.newItem.priceid
      )[0];
      this.newItem.price = Round2(price.price);
      this.newItem.spec = price.name;
      this.computeAmount();
    },
    computeAmount() {
      let res = this.newItem.count * this.newItem.price;
      this.newItem.amount = Round2(res);
    },
    clearItem() {
      this.newItem.id = "";
      this.newItem.title = "";
      this.newItem.picture = "";
      this.newItem.spec = "";
      this.newItem.priceid = "";
      this.newItem.price = 0;
      this.newItem.count = 1;
      this.newItem.amount = 0;
      this.newItemPrices = [];
      this.addedToBasket = false;
    },
    showToBasket(item) {
      let price = Object.assign({}, item);
      this.clearItem();
      this.newItem.id = price.id;
      this.newItem.title = price.title;
      this.newItem.picture = price.picture;
      this.newItem.priceid = price.price[0].id;
      this.newItem.spec = price.price[0].name;
      this.newItem.price = Round2(price.price[0].price);
      this.newItem.amount = Round2(price.price[0].price);
      this.newItem.availablefrom = price.availablefrom;
      this.newItem.availableto = price.availableto;
      this.newItemPrices = price.price;
      this.addedToBasket = false;
      this.tobasketModal = true;
    },
    onAddToBasket() {
      this.$store.dispatch("addToOrder", Object.assign({}, this.newItem));
      this.addedToBasket = true;
    },
    onGoToBasket() {
      this.tobasketModal = false;
      this.$router.push({ path: "/cart/" + this.id });
    },
    onOrder() {
      this.tobasketModal = false;
      this.$router.push({ path: "/cart/" + this.id });
    },
  },
  created() {
    this.$store.dispatch("fetchMenuBkg", this.id);
    this.$store.dispatch("fetchDishes", this.id);
    this.$store.dispatch("fetchCategories", this.id);
    this.$store.dispatch("fetchInfo", this.id);
    this.langVisible = !this.$store.state.lang;
    VisitCount(this.id).then(response => {
      if (response.data.result) {
        this.visits = response.data.result;
      }
    });
  },
  computed: {
    ...mapState({
      cats: state => state.cats,
      dishes: state => state.dishes,
      bkg: state => state.menubkg
    }),
    fileurl() {
      return fileUrl;
    },
    image() {
      return this.bkg ? this.fileurl + this.bkg : "";
    },
    first() {
      return this.cats.filter(c => c.parentid === "");
    },
    ds() {
      return this.dishes.filter(
        c =>
          (c.parentid === this.cid &&
            this.subid === "all" &&
            this.search === "") ||
          (c.categoryid === this.subid && this.search === "") ||
          (!this.cid &&
            this.first.length > 0 &&
            c.parentid === this.first[0].id &&
            this.search === "") ||
          (this.search !== "" &&
            c.title.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
      );
    },
    dscount() {
      return this.ds.length;
    }
  },

  watch: {
    cid() {
      if (this.cid !== "search") {
        this.catpath = this.first[this.$refs.colcats.isActive - 1].name;
        this.search = "";
      }
    },
    subid() {
      if (this.cid !== "search") {
        this.refreshPath();
        this.search = "";
      }
    },
    search() {
      this.refreshPath();
    }
  }
};
</script>

<style lang="scss" scoped>
.mt-3 {
  margin-top: 1.875rem * 2;
}
.mb-0 {
  margin-bottom: 0;
}
.is-active {
  font-weight: 800;
}
.text-left {
  text-align: left;
}
@media only screen and (max-width: 600px) {
  .text-left {
    text-align: center;
  }
}
.text-right {
  text-align: right;
}
.text-center {
  text-align: center;
}
.vertical-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.padding-top-20 {
  padding-top: 20px;
}

.sticky-ordernow {
  position: fixed;
  right: 30px;
  bottom: 0;
  z-index: 1000;
}

.sticky-menu {
  position: -webkit-sticky; // required for Safari
  position: sticky;
  top: 70px; // required as well.
  z-index: 1000000;
  background: white;
}

.scroll {
  margin: 4px, 4px;
  padding: 4px;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}
</style>
